export default __webpack_public_path__ + "static/media/Provider_timezone.5e247e48.svg";